<template>
  <b-sidebar
    id="sidebar-create-uz-asbo"
    ref="sidebar"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Create list') }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <b-form
        class="p-2"
        @submit.prevent
      >
        <b-alert
          variant="info"
          show
          class="p-1"
        >
          <small>
            {{ $t('uz asbo create hint') }}
          </small>
        </b-alert>

        <b-form-group
          :label="$t('Year')"
          label-for="uz-asbo-year"
        >
          <v-select
            id="uz-asbo-year"
            v-model="year"
            :options="years"
            :clearable="false"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Month')"
          label-for="uz-asbo-month"
        >
          <v-select
            id="uz-asbo-month"
            v-model="month"
            :options="months"
            :reduce="option => option.id"
            :get-option-label="option => $langName(option.name)"
            :clearable="false"
          />
        </b-form-group>

        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            :disabled="isBusy || !year || !month"
            @click="submit(hide)"
          >
            <b-spinner
              v-if="isBusy"
              small
              class="mr-50"
            />
            {{ $t('Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="hide"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton, BAlert, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { MONTHS, yearOptions } from './config'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    BAlert,
    BSpinner,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    const now = new Date()
    return {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      months: MONTHS,
      years: yearOptions(),
      isBusy: false,
    }
  },
  methods: {
    submit(hide) {
      this.isBusy = true
      this.$store.dispatch('uzAsbo/create', { year: this.year, month: this.month })
        .then(() => {
          this.$bvToast.toast(this.$t('Successfully completed'), {
            variant: 'success',
            solid: true,
            title: this.$t('Success'),
          })
          hide()
          this.$emit('refetchData')
        })
        .catch(error => {
          this.$errorSwal(this, error)
        })
        .finally(() => {
          this.isBusy = false
        })
    },
  },
}
</script>
